<template>
  <div>
    <!-- リスト -->
    <ul
      :class="[
        s.list,
        isDevelop ? s.isDevelop : '',
      ]"
      v-if="!activeItemName">
      <li
        v-for="item in items"
        :key="item.name">
        <div>
          <i :class="item.icon"/>
          <div :class="s.content">
            <div v-if="item.name === 'driver'">{{ user.username }}</div>
            <div v-if="item.name === 'vehicle'">
              <div v-if="user.vehicles[0]">
                <div>{{ user.vehicles[0].label }}</div>
                <div>{{ user.vehicles[0].name }}</div>
                <div>{{ user.vehicles[0].number }}</div>
              </div>
              <div v-else>車両を選択してください</div>
            </div>
            <div v-if="item.name === 'taxiStand'">{{ user.taxiStand[0]?.label || '待機所を選択してください' }}</div>

            <div
              :class="s.btn"
              v-if="item.hasBtn"
              @click="iconClicked(item.name)">
              <i :class="item.btnIcon"/>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <!-- セレクトなど -->
    <div v-else>
      <div
        class="p-3 bdr-b"
        @click="activeItemName = null"><i class="fa-solid fa-angle-left me-3"/>戻る</div>
      <ChangeVehicleForm v-if="activeItemName === 'vehicle'"/>
      <ChangeTaxiStandForm v-if="activeItemName === 'taxiStand'"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  ChangeVehicleForm,
  ChangeTaxiStandForm,
} from '@/components/parts';

export default {
  name: 'setting',
  components: {
    ChangeVehicleForm,
    ChangeTaxiStandForm,
  },
  data() {
    return {
      activeItemName: null,
      items: [
        {
          name: 'driver',
          icon: 'fa-solid fa-user-tie',
          btnIcon: 'fa-solid fa-arrow-right-from-bracket',
          hasBtn: true,
        },
        {
          name: 'vehicle',
          icon: 'fa-solid fa-car',
          btnIcon: 'fa-solid fa-triangle fa-rotate-180',
          hasBtn: true,
        },
        {
          name: 'taxiStand',
          icon: 'fa-solid fa-map-pin',
          btnIcon: 'fa-solid fa-triangle fa-rotate-180',
          hasBtn: true,
        },
      ],
    };
  },
  computed: {
    ...mapState(['user']),
    isDevelop() {
      return location.href.includes('https://dev') || location.href.includes('localhost');
    },
  },
  methods: {
    iconClicked(name) {
      if (name === 'driver') this.logout();
      else this.activeItemName = name;
    },
    logout() {
      this.$store.dispatch('user/login/logout');
    },
  },
};
</script>

<style lang="scss" module="s">
.list {
  > li {
    > * {
      padding: 16px 24px;
      font-weight: bold;
      border-bottom: 1px solid var(--border-gray);
      display: flex;
      align-items: center;
      .content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn {
          opacity: .3;
          i {
            margin: 0;
          }
        }
      }
    }

    i {
      margin-right: 16px;
      width: 20px;
    }
  }

  &.isDevelop {
    padding-bottom: 50px;
  }
}
</style>
